document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".product__tax.caption.rte");
  const insertAfterElement = document.querySelector(
    ".tee-block.tee-product-price"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }

  var elements = document.querySelectorAll('.tee-option__title');
  elements.forEach(function(element) {
      var html = element.innerHTML;
      if (element.children.length === 0 && html.indexOf("no-uppercase") < 0) {
          element.innerHTML = html.replace(/ß/g, '<span class="no-uppercase">ß</span>');
      }
  });
});

document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});



document.addEventListener("teeinblue-event-component-injected", function () {
  function attachEventToCartLink() {
    const cartLink = document.querySelector('.tee-form-responses a[href="/cart"]');
    if (cartLink && !cartLink.dataset.eventBound) {
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
  
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
            .then(res => res.json())
            .then(res => drawer.renderContents({ sections: res }));
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        }
      });
      cartLink.dataset.eventBound = "true";
    }
  }
  
  const observer = new MutationObserver(() => {
    attachEventToCartLink();
  });
  
  observer.observe(document.body, {
    childList: true, 
    subtree: true,   
  });
  attachEventToCartLink();
})
